import { Module } from "../plugins/_application";

var $ = jQuery;

export default class LoadActivities extends Module {

  ready(app) {

    $('.activities-container.button-container').on('click', 'button.load', function (e) {
      e.preventDefault();
      
      let BUTTON = $(e.currentTarget);
      let LOADER = $('#loader-overlay');

      LOADER.show();

      const ACTIVITY_SELECT_TYPE = BUTTON.attr('data-activity-select-type')
      const ACTIVITY_PLACE = BUTTON.attr('data-activity-place')
      const ACTIVITY_CATEGORY = BUTTON.attr('data-activity-category')

      // Set ajax data
			let data = {
        'action': 'load_more_activities',
        'activity_page_number': BUTTON.attr('data-activity-page'),
        'activity_select_type': ACTIVITY_SELECT_TYPE,
        'activity_place': ACTIVITY_PLACE,
        'activity_category': ACTIVITY_CATEGORY,
        };

        // Ajax call
        jQuery.post(main_theme_objects.ajax_url, data, function(response) {

        if (response.data != undefined) {
          let ACTIVITY_CONTAINER = $('.activities-container.all-activities');
          ACTIVITY_CONTAINER.html(ACTIVITY_CONTAINER.html() + response.data.html);
          
          BUTTON.attr('data-activity-page', response.data.paged);

          const HAS_MORE = response.data.has_more !== undefined
            ? response.data.has_more
            : response.data.max_pages !== response.data.paged;

          if (!HAS_MORE) {
            BUTTON.hide()
          }
        }
        
        // Hide loader
          LOADER.hide();

        });
    })

  }
}